import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TopNav from '../containers/navs/Topnav';
import Sidebar from '../containers/navs/Sidebar';
import { AxiosAPI, getUserID, getGroupID, getUserRole } from '../helpers/AxiosAPI';
import {
  gAPI_Users_By_Id,
  gAPI_Property_List_By_Group,
} from '../constants/APIs';
import { changeUser, changeUserName } from '../redux/actions';
import logo from './../assets/myma_logo.png';
class AppLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: 'Admin',
      renderNav: false,
      propertyList: [],
      propertyId: '',
      userData: undefined,
    };
  }

  componentDidMount() {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    })
      .then((res) => {
        this.props.changeUser(res.data.email);
        this.props.changeUserName(res.data.fullName);
        this.setState({ userData: res.data });

        res.data.roles.forEach((r) => {
          if (r === 'User' && res.data.roles.length === 1) {
            this.setState({ role: 'User' });
          } else if (r === 'Agent' && res.data.roles.length === 1) {
            this.setState({ role: 'Agent' });
          }
        });

        AxiosAPI({
          method: 'get',
          url: `${gAPI_Property_List_By_Group}?group_id=${getGroupID()}`,
        })
          .then((pres) => {
            let property_id = this.props.propertyId;

            //console.log('property_id', property_id);
            // if (property_id === '-1') {
            //   property_id = ''
            // }
            if (
              res.data.properties.length > 0 &&
              res.data.properties[0] === '-1'
            ) {
              const hotel = pres.data.find((elem) => {
                return elem.id === property_id;
              });

              if (hotel) {
              } else if (property_id === '-1') {
                property_id = '-1';
              } else {
                property_id = pres.data[0].id;
              }
              this.setState({
                propertyList: pres.data,
                propertyId: property_id,
              });
            } else {
              const finalResult = [];
              pres.data.forEach((p) => {
                res.data.properties.forEach((r) => {
                  if (p.id === r) {
                    finalResult.push({
                      id: p.id,
                      name: p.name,
                      websiteLink: p.websiteLink,
                      rooms: p.rooms,
                      starRating: p.starRating,
                      type: p.type,
                      groupName: p.groupName,
                      isBmb: p.isBmb,
                      isAiva: p.isAiva,
                      timeZone: p.timeZone
                    });
                  }
                });
                //console.log(finalResult);
              });

              const hotel = finalResult.find((elem) => {
                return elem.id === property_id;
              });

              if (hotel) {
              } else if (property_id === '-1') {
                property_id = '-1';
              } else {
                property_id = finalResult[0].id;
              }
              this.setState({
                propertyList: finalResult,
                propertyId: property_id,
              });
            }
            this.setState({ renderNav: true });
          })
          .catch((err) => console.error(err));
      })
      .catch((err) => console.error(err));
  }

  render() {
    const { containerClassnames } = this.props;
    return (
      <div id="app-container" className={containerClassnames}>
        {this.state.renderNav ? (
          <Fragment>
            <TopNav
              history={this.props.history}
              plist={this.state.propertyList}
              pid={this.state.propertyId}
              role={this.state.role}
              userData={this.state.userData}
            />
            <Sidebar role={this.state.role} pid={this.state.propertyId} />
          </Fragment>
        ) : (
          <Fragment>
            <nav className="navbar fixed-top">
              <a className="navbar-logo" href="/">
                {(this.props.serviceProviderLogo !== undefined && this.props.serviceProviderLogo != null && this.props.serviceProviderLogo !== '') &&
                  <img src={this.props.serviceProviderLogo} width={1168 / 9} height={158 / 2} alt="logo" />
                  // :
                  // <img src={logo} width={1168 / 9} height={158 / 2} alt="logo" />
                }
              </a>
            </nav>
            <div className="sidebar">
              <div className="main-menu"></div>
            </div>
          </Fragment>
        )}
        <main>
          <div className="container-fluid">{this.props.children}</div>
        </main>
      </div>
    );
  }
}

const mapStateToProps = ({ menu, settings }) => {
  const { containerClassnames } = menu;
  const { locale, propertyId, serviceProviderLogo } = settings;
  return {
    containerClassnames,
    locale,
    propertyId,
    serviceProviderLogo
  };
};
const mapActionToProps = { changeUser, changeUserName };

export default withRouter(
  connect(mapStateToProps, mapActionToProps)(AppLayout)
);
